import axios from "axios";
import { Lead_Service_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const getViewLeadManagementActions = {
  GET_VIEW_LEAD_MANAGEMENT_SUCCESS: "GET_VIEW_LEAD_MANAGEMENT_SUCCESS",
  GET_VIEW_LEAD_MANAGEMENT_ERROR: "GET_VIEW_LEAD_MANAGEMENT_ERROR",
};

export function getViewLeadManagmentDetails(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/get/getLeadDetails?leadId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getViewLeadManagementSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getViewLeadManagementError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response.status == 403) {
          dispatch(clearLogoutData());
        } else {
          if (err.response) {
            dispatch(getViewLeadManagementError(err));
            return err.response;
          }
        }
      });
}

export function getViewLeadManagementError(error) {
  return {
    type: getViewLeadManagementActions.GET_VIEW_LEAD_MANAGEMENT_ERROR,
    payload: error,
  };
}

export function getViewLeadManagementSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getViewLeadManagementActions.GET_VIEW_LEAD_MANAGEMENT_SUCCESS,
      payload: props,
    });
  };
}
